export function ScoreBar({ label, score, confidence }: { label: string; score: number | null | undefined; confidence?: 'high' | 'medium' | 'low' }): JSX.Element {
  const value = typeof score === 'number' ? Math.max(0, Math.min(10, score)) : null;
  const pct = value !== null ? (value / 10) * 100 : 0;
  const colour = value === null
    ? 'bg-ink-200'
    : value >= 8 ? 'bg-emerald-500'
    : value >= 5 ? 'bg-sky-500'
    : value >= 3 ? 'bg-amber-500'
    : 'bg-red-500';
  const dim = confidence === 'low' ? 'opacity-60' : confidence === 'medium' ? 'opacity-80' : '';
  return (
    <div className="flex items-center gap-2 text-[11px]">
      <span className="w-32 shrink-0 text-ink-600">{label}</span>
      <div className={`flex-1 h-2 rounded bg-ink-100 overflow-hidden ${dim}`}>
        <div className={`h-full ${colour} transition-all`} style={{ width: `${pct}%` }} />
      </div>
      <span className="w-10 text-right tabular-nums text-ink-700">{value === null ? '—' : `${value}/10`}</span>
    </div>
  );
}
